(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-dp-routines-root]';

  function getRootPath() {
    var route =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root;

    return route || '/';
  }

  function parseResponse(response) {
    var contentType = response.headers.get('content-type') || '';

    if (contentType.indexOf('application/json') !== -1) {
      return response.json();
    }

    return response.text().then(function (text) {
      return {
        description: text || 'Došlo je do neočekivane greške.'
      };
    });
  }

  function initRoot(root) {
    if (!root) return;

    if (typeof root._dpRoutinesCleanup === 'function') {
      root._dpRoutinesCleanup();
    }

    root.classList.add('is-js');

    var cleanup = [];
    var slider = root.querySelector('[data-dp-slider]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-dp-card]'));
    var progress = root.querySelector('[data-dp-progress]');
    var currentCounter = root.querySelector('[data-dp-current]');
    var reducedMotion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    var revealObserver = null;
    var visibilityObserver = null;
    var scrollFrame = null;

    function on(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options || false);
      cleanup.push(function () {
        target.removeEventListener(eventName, handler, options || false);
      });
    }

    function setupVisibility() {
      if (!('IntersectionObserver' in window)) {
        root.classList.add('is-in-view');
        return;
      }

      visibilityObserver = new IntersectionObserver(
        function (entries) {
          var index;

          for (index = 0; index < entries.length; index += 1) {
            if (entries[index].isIntersecting) {
              root.classList.add('is-in-view');
            } else {
              root.classList.remove('is-in-view');
            }
          }
        },
        {
          threshold: 0.01,
          rootMargin: '160px 0px'
        }
      );

      visibilityObserver.observe(root);
    }

    function setupReveal() {
      var items = Array.prototype.slice.call(
        root.querySelectorAll('[data-dp-reveal]')
      );

      if (
        !('IntersectionObserver' in window) ||
        reducedMotion ||
        root.classList.contains('dp-routines--motion-off')
      ) {
        items.forEach(function (item) {
          item.classList.add('is-visible');
        });
        return;
      }

      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -4% 0px'
        }
      );

      items.forEach(function (item) {
        revealObserver.observe(item);
      });
    }

    function updateSlider() {
      if (!slider || !progress || !currentCounter || cards.length < 2) return;

      var sliderRect = slider.getBoundingClientRect();
      var targetX = sliderRect.left + Math.min(sliderRect.width * 0.32, 150);
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.getBoundingClientRect().left - targetX);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      var current = closestIndex + 1;
      currentCounter.textContent = String(current).padStart(2, '0');
      progress.style.width = ((current / cards.length) * 100) + '%';
    }

    function setupSlider() {
      if (!slider) return;

      function handleScroll() {
        if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateSlider);
      }

      on(slider, 'scroll', handleScroll, { passive: true });
      on(window, 'resize', updateSlider, { passive: true });
      updateSlider();
    }

    function updateRoutineButtons(routineKey, state, label) {
      var selector =
        '[data-dp-add-routine][data-routine-key="' + routineKey + '"]';
      var buttons = root.querySelectorAll(selector);
      var index;

      for (index = 0; index < buttons.length; index += 1) {
        var button = buttons[index];
        var labelElement = button.querySelector('[data-dp-button-label]');

        if (!button.getAttribute('data-original-label')) {
          button.setAttribute(
            'data-original-label',
            button.getAttribute('data-default-label') ||
              (labelElement
                ? labelElement.textContent.replace(/^\s+|\s+$/g, '')
                : 'Dodaj rutinu u korpu')
          );
        }

        button.disabled =
          state === 'loading' ||
          button.getAttribute('data-no-items') === 'true';

        button.setAttribute(
          'aria-busy',
          state === 'loading' ? 'true' : 'false'
        );

        if (labelElement && label) labelElement.textContent = label;
      }
    }

    function resetRoutineButtons(routineKey) {
      var selector =
        '[data-dp-add-routine][data-routine-key="' + routineKey + '"]';
      var buttons = root.querySelectorAll(selector);
      var index;

      for (index = 0; index < buttons.length; index += 1) {
        var button = buttons[index];
        var labelElement = button.querySelector('[data-dp-button-label]');

        if (labelElement) {
          labelElement.textContent =
            button.getAttribute('data-original-label') ||
            button.getAttribute('data-default-label') ||
            'Dodaj rutinu u korpu';
        }

        button.disabled = button.getAttribute('data-no-items') === 'true';
        button.removeAttribute('aria-busy');
      }
    }

    function setRoutineStatus(routineKey, message, isError) {
      var selector =
        '[data-dp-routine-status="' + routineKey + '"]';
      var statuses = root.querySelectorAll(selector);
      var index;

      for (index = 0; index < statuses.length; index += 1) {
        statuses[index].textContent = message || '';
        statuses[index].style.color = isError ? '#8a4f42' : '';
      }
    }

    function updateCartBubble(cart) {
      var count = Number(cart && cart.item_count ? cart.item_count : 0);
      var selectors = [
        '.cart-bubble',
        '.cart-count-bubble',
        '[data-cart-count-bubble]',
        '[data-cart-count]',
        '[data-cart-count-text]'
      ];

      var elements = document.querySelectorAll(selectors.join(','));
      var index;

      for (index = 0; index < elements.length; index += 1) {
        var element = elements[index];
        var explicitText = element.matches(
          '[data-cart-count], [data-cart-count-text]'
        );

        var numberTarget = explicitText
          ? element
          : element.querySelector(
              '[data-cart-count], [data-cart-count-text], span:not(.visually-hidden)'
            );

        var text = count > 99 ? '99+' : String(count);

        if (numberTarget) {
          numberTarget.textContent = text;
        } else if (!element.children.length) {
          element.textContent = text;
        }

        element.hidden = count === 0;
        element.classList.toggle('is-empty', count === 0);
        element.classList.toggle('hidden', count === 0);
        element.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      }
    }

    function refreshCartDrawer() {
      var rootPath = getRootPath();
      var separator = rootPath.indexOf('?') !== -1 ? '&' : '?';

      return fetch(
        rootPath + separator + 'sections=cart-drawer-section',
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Cart drawer se nije mogao osvježiti.');
          }
          return response.json();
        })
        .then(function (sections) {
          var html = sections && sections['cart-drawer-section'];
          if (!html) return;

          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var newInner = parsed.querySelector('.cart-drawer__inner');
          var currentInner = document.querySelector(
            '#cart-drawer .cart-drawer__inner, .cart-drawer__inner'
          );

          if (newInner && currentInner) {
            currentInner.replaceWith(newInner);
            return;
          }

          var newDrawer = parsed.querySelector('#cart-drawer');
          var currentDrawer = document.querySelector('#cart-drawer');

          if (newDrawer && currentDrawer) {
            currentDrawer.replaceWith(newDrawer);
          }
        });
    }

    function openCartDrawer() {
      var drawer =
        document.querySelector('#cart-drawer') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('[data-cart-drawer]');

      if (!drawer) return;

      try {
        if (typeof drawer.open === 'function') {
          drawer.open();
        } else if (typeof drawer.show === 'function') {
          drawer.show();
        } else if (
          typeof drawer.showModal === 'function' &&
          !drawer.open
        ) {
          drawer.showModal();
        }
      } catch (error) {
        console.warn(
          '[Dar Prirode routines] Drawer method could not be called.',
          error
        );
      }

      drawer.removeAttribute('aria-hidden');
      drawer.setAttribute('open', '');
      drawer.classList.add('active', 'is-open', 'animate');
      document.body.classList.add('overflow-hidden');
    }

    function postItems(items) {
      return fetch(getRootPath() + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        return parseResponse(response).then(function (payload) {
          if (!response.ok) {
            var error = new Error(
              payload.description ||
                payload.message ||
                'Proizvodi se nisu mogli dodati.'
            );
            error.status = response.status;
            throw error;
          }

          return payload;
        });
      });
    }

    function addWithFallback(items) {
      return postItems(items)
        .then(function () {
          return {
            added: items,
            failed: []
          };
        })
        .catch(function (bulkError) {
          var added = [];
          var failed = [];
          var chain = Promise.resolve();

          items.forEach(function (item) {
            chain = chain.then(function () {
              return postItems([item])
                .then(function () {
                  added.push(item);
                })
                .catch(function () {
                  failed.push(item);
                });
            });
          });

          return chain.then(function () {
            if (!added.length) throw bulkError;

            return {
              added: added,
              failed: failed
            };
          });
        });
    }

    function handleAddClick(button) {
      var items = [];
      var unavailable = [];

      try {
        items = JSON.parse(button.getAttribute('data-items') || '[]');
      } catch (error) {
        items = [];
      }

      try {
        unavailable = JSON.parse(
          button.getAttribute('data-unavailable') || '[]'
        );
      } catch (error) {
        unavailable = [];
      }

      if (!items.length) {
        button.setAttribute('data-no-items', 'true');
        button.disabled = true;
        return;
      }

      var routineKey = button.getAttribute('data-routine-key');

      updateRoutineButtons(routineKey, 'loading', 'Dodajem rutinu...');
      setRoutineStatus(routineKey, '');

      addWithFallback(items)
        .then(function (result) {
          return fetch(getRootPath() + 'cart.js', {
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (cartResponse) {
            return parseResponse(cartResponse).then(function (cart) {
              if (!cartResponse.ok) {
                throw new Error('Korpa se nije mogla osvježiti.');
              }

              updateCartBubble(cart);

              return refreshCartDrawer()
                .catch(function (drawerError) {
                  console.warn('[Dar Prirode routines]', drawerError);
                })
                .then(function () {
                  if (
                    typeof window.DarPrirodeInitCartDrawer === 'function'
                  ) {
                    try {
                      window.DarPrirodeInitCartDrawer();
                    } catch (error) {
                      console.warn(error);
                    }
                  }

                  document.dispatchEvent(
                    new CustomEvent('cart:refresh', {
                      bubbles: true,
                      detail: {
                        cart: cart,
                        source: 'dar-prirode-routines'
                      }
                    })
                  );

                  document.dispatchEvent(
                    new CustomEvent('cart:update', {
                      bubbles: true,
                      detail: {
                        cart: cart,
                        source: 'dar-prirode-routines'
                      }
                    })
                  );

                  root.dispatchEvent(
                    new CustomEvent('dp-routine:close-modals')
                  );

                  openCartDrawer();
                  updateRoutineButtons(routineKey, 'success', 'Dodano ✓');

                  var failedNames = unavailable.concat(
                    result.failed
                      .map(function (item) {
                        return item.title;
                      })
                      .filter(Boolean)
                  );

                  failedNames = failedNames.filter(
                    function (name, index, array) {
                      return array.indexOf(name) === index;
                    }
                  );

                  if (failedNames.length) {
                    setRoutineStatus(
                      routineKey,
                      'Dodani su dostupni proizvodi. Nije dodano: ' +
                        failedNames.join(', ') +
                        '.',
                      true
                    );
                  } else {
                    setRoutineStatus(
                      routineKey,
                      'Cijela rutina je dodana u korpu.'
                    );
                  }

                  window.setTimeout(function () {
                    resetRoutineButtons(routineKey);
                  }, 2200);
                });
            });
          });
        })
        .catch(function (error) {
          console.error('[Dar Prirode routines]', error);

          setRoutineStatus(
            routineKey,
            error.message ||
              'Rutina se trenutno ne može dodati. Pokušajte ponovo.',
            true
          );

          updateRoutineButtons(
            routineKey,
            'error',
            'Pokušajte ponovo'
          );

          window.setTimeout(function () {
            resetRoutineButtons(routineKey);
          }, 2400);
        });
    }

    function handleRootClick(event) {
      var button = event.target.closest
        ? event.target.closest('[data-dp-add-routine]')
        : null;

      if (!button || !root.contains(button) || button.disabled) return;

      event.preventDefault();
      handleAddClick(button);
    }

    on(root, 'click', handleRootClick);

    setupVisibility();
    setupReveal();
    setupSlider();

    root._dpRoutinesCleanup = function () {
      var index;

      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      if (revealObserver) revealObserver.disconnect();
      if (visibilityObserver) visibilityObserver.disconnect();

      for (index = 0; index < cleanup.length; index += 1) {
        cleanup[index]();
      }

      root._dpRoutinesCleanup = null;
    };
  }

  function init(scope) {
    var roots = [];
    var found;
    var index;

    scope = scope || document;

    if (
      scope.nodeType === 1 &&
      scope.matches &&
      scope.matches(ROOT_SELECTOR)
    ) {
      roots.push(scope);
    }

    if (scope.querySelectorAll) {
      found = scope.querySelectorAll(ROOT_SELECTOR);

      for (index = 0; index < found.length; index += 1) {
        roots.push(found[index]);
      }
    }

    for (index = 0; index < roots.length; index += 1) {
      initRoot(roots[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector(ROOT_SELECTOR)
      : null;

    if (
      event.target.matches &&
      event.target.matches(ROOT_SELECTOR)
    ) {
      root = event.target;
    }

    if (root && typeof root._dpRoutinesCleanup === 'function') {
      root._dpRoutinesCleanup();
    }
  });
})();
